<template src="./TabDeliveryPartnerComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, nextTick} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import {useRouter} from "vue-router";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import ButtonExportBillComponent from "@/components/buttons/button-export-bill/ButtonExportBillComponent.vue";
import ExportBillComponent from "@/components/export-bills/ExportBillComponent.vue";

export default {
  name: 'TabDeliveryPartnerComponent',
  components: {
    ExportBillComponent,
    ButtonExportBillComponent,
    InputCheckboxOne,
    InputDateTimeNormal,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  props: {
    tabCurrent: {
      type: Number,
      required: false,
      default: () => 2
    },
  },
  setup(props) {
    const dataHeaderTable = ref({
      exchange_delivery_name: {
        label: 'Tên dữ liệu giao hàng',
        order: 2,
        width: '25%',
      },
      companyNameReceiver: {
        label: 'Đối tác',
        order: 3,
        width: '25%',
      },
      sumAmount: {
        label: 'Tổng tiền gốc',
        order: 4,
        width: '15%',
      },
      sumTaxAmount: {
        label: 'Tổng tiền <br> (bao gồm thuế)',
        order: 5,
        width: '15%',
      },
      status: {
        label: 'Trạng thái',
        order: 6,
        width: '15%',
      },
      timeCreated: {
        label: 'Ngày tạo phiếu',
        order: 7,
        width: '15%',
      },
      delivery_date: {
        label: 'Ngày chấp thuận',
        order: 8,
        width: '15%',
      },
      time_approved: {
        label: 'Ngày giao hàng',
        order: 9,
        width: '15%',
      },
      action_export: {
        label: 'Export',
        order: 10,
        width: '10%',
      },
    })
    const dataBillToPrint = ref({});
    const isShowBill = ref(false);
    const labelButtonExportBill = ref('In')
    const labelButtonSearch = ref('Tìm kiếm')
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const labelButtonCreate = ref('Tạo dữ liệu giao hàng')
    const urlOrigin = ref('/v1/m-deliveries/store-master-deliveries/')
    const dataSearch = ref({
      exchange_delivery_name: {
        id: 'exchange_delivery_name',
        label: 'Tên dữ liệu giao hàng',
        placeholder: 'Tên dữ liệu giao hàng',
        value: ''
      },
      partner_name: {
        id: 'partner_name',
        label: 'Tên đối tác',
        placeholder: 'Tên đối tác',
        value: ''
      },
      partner_code: {
        id: 'partner_code',
        label: 'Mã đối tác',
        placeholder: 'Mã đối tác',
        value: ''
      },
      status: {
        id: 'status',
        label: 'Trạng thái',
        placeholder: 'Trạng thái',
        value: '',
        options: [
          {
            name: CommonService.compareStatusDeliveryLabel(AppConstant.DELIVERY_STATUS_SENT),
            value: AppConstant.DELIVERY_STATUS_SENT
          },
          {
            name: CommonService.compareStatusDeliveryLabel(AppConstant.DELIVERY_STATUS_IN_PROCESS),
            value: AppConstant.DELIVERY_STATUS_IN_PROCESS
          },
          {
            name: CommonService.compareStatusDeliveryLabel(AppConstant.DELIVERY_STATUS_REFLECTION),
            value: AppConstant.DELIVERY_STATUS_REFLECTION
          },
          {
            name: CommonService.compareStatusDeliveryLabel(AppConstant.DELIVERY_STATUS_APPROVED),
            value: AppConstant.DELIVERY_STATUS_APPROVED
          },
          {
            name: CommonService.compareStatusDeliveryLabel(AppConstant.DELIVERY_STATUS_REJECT),
            value: AppConstant.DELIVERY_STATUS_REJECT
          }
        ]
      },
      time_created: {
        id: 'time_created',
        label: 'Ngày gửi đến',
        placeholder: 'Ngày gửi đến',
        value: ''
      },
      delivery_date: {
        id: 'delivery_date',
        label: 'Ngày giao hàng',
        placeholder: 'Ngày giao hàng',
        value: ''
      },
      time_approved: {
        id: 'time_approved',
        label: 'Ngày chấp thuận',
        placeholder: 'Ngày chấp thuận',
        value: ''
      },
    })
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_COMMON))
    const selectLimit = ref(CommonService.showDropdownLimitRecord())
    const limitDefault = ref(0)
    const deliveryStore = useDeliveryStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    watch(() => props.tabCurrent, (newTab) => {
      if(newTab === AppConstant.TAB_PARTNER) {
        getListDelivery(router.currentRoute.value.query.page ?? AppConstant.PAGE_DEFAULT);
      }
    });
    function onChange(value, name) {
      dataSearch.value[name].value = value
    }


    const listDeliveries = computed(() => {
      return deliveryStore.deliveries;
    });

    const paginate = computed(() => {
      return deliveryStore.paginate;
    });

    watch(() => deliveryStore.deliveries, (newListDeliveries) => {
      newListDeliveries.forEach((delivery) => {
        if(checkItems.value[delivery.id] === undefined) {
          checkItems.value[delivery.id] = false
        }
      })
    });

    function emitPage(page) {
      getListDelivery(page);
    }

    async function getListDelivery(page, limit = AppConstant.LIMIT_PAGE_5) {
      const params = {
        id: accountStore.account.company.id,
        delivery_name: dataSearch.value.exchange_delivery_name.value,
        partner_name: dataSearch.value.partner_name.value,
        partner_code: dataSearch.value.partner_code.value,
        delivery_date: dataSearch.value.delivery_date.value,
        status: dataSearch.value.status.value,
        created_at: dataSearch.value.time_created.value,
        approved_date: dataSearch.value.time_approved.value,
        page: page,
        take: limit
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/delivery-list-partner-limit';
      await deliveryStore.getListDeliveries(url, params);
    }

    function searchDeliveries() {
      getListDelivery(AppConstant.PAGE_DEFAULT);
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listDeliveries.value.forEach((delivery) => {
          if(checkItems.value[delivery.id] === undefined) {
            listItemSelected.value.push(delivery.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listDeliveries.value.forEach((delivery) => {
        if(checkItems.value[delivery.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value[delivery.id] === undefined) {
          listItemSelected.value.push(delivery.id)
        }else if (!value && listItemSelected.value[delivery.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(delivery.id), 1);
        }
      })

      checkAll.value = false
      if(counterChecked === listDeliveries.value.length) {
        checkAll.value = true
      }
    }

    function redirectToDetail(deliveryId) {
      router.push({ name: 'DeliveryDetail', query: {'id': deliveryId, 'type': AppConstant.TAB_PARTNER}})
    }

    function onChangeAction(value) {
      switch (parseInt(value)) {
        case AppConstant.ACTION_TYPE_DELETE:
          if(listItemSelected.value.length === 0) {
            CommonService.showAlertPopup({
              title: 'Vui lòng chọn dữ liệu để thực hiện!',
              icon: "warning",
              showConfirmButton: false,
              timer: 1500,
              width: '800px'
            });
          }
      }
    }

    function onChangeLimit(value) {
      const currentLimit = limitDefault.value
      limitDefault.value = value
      if(currentLimit > 0) {
        getListDelivery(AppConstant.PAGE_DEFAULT, limitDefault.value)
      }
    }

    async function exportBillDelivery(delivery_id) {
      const params = {
        id: accountStore.account.company.id,
        delivery_id: delivery_id,
        type: AppConstant.TAB_PARTNER
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/delivery-detail';

      try {
        await deliveryStore.getListMasterDelivery(url, params, AppConstant.EXPORT_BILL_TRUE);
        const delivery_export = deliveryStore.delivery_export;

        // Gán dữ liệu cho bill
        dataBillToPrint.value = {
          date: delivery_export.delivery_date,
          partnerName: delivery_export.m_company_receiver ? delivery_export.m_company_receiver.company_zip + ' - ' + delivery_export.m_company_receiver.company_name : '',
          items: delivery_export.deliveryDetails,
          total: delivery_export.sum_tax_included
        };

        isShowBill.value = false;
        nextTick(() => {
          isShowBill.value = true;
        });
      } catch (err) {
        console.error('Lỗi lấy chi tiết đơn hàng:', err);
      }
    }

    return {
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      urlOrigin,
      dataSearch,
      deliveryStore,
      accountStore,
      checkAll,
      listDeliveries,
      paginate,
      selectAction,
      selectLimit,
      checkItems,
      redirectToDetail,
      onChangeSelectItem,
      searchDeliveries,
      onChange,
      onChangeAction,
      emitPage,
      onChangeSelectAll,
      onChangeLimit,
      CommonService,
      CommonText,
      exportBillDelivery,
      labelButtonExportBill,
      isShowBill,
      dataBillToPrint
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);

      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .btn-create-data {
          width: 200px;
          margin-top: 50px;
        }

        .list-partners-component {
          margin-top: 30px;

          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }

          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
